<template>
  <a-card>
    <div class="cardBody">
      <a-form>
        <div>
          <div>
            <a-checkbox
              @change="subsMailingList"
              v-model="formData.subscribeMailingList"
            >
              Subscribe to CW Home Depot’s Mailing List
            </a-checkbox>
            <br />
            <span class="checkbox-container">
              <a-checkbox
                v-model="formData.termsAndCondition"
                :disabled="true"
              />
              <span class="checkbox-label">
                &nbsp; I have read and agreed to the
                <a href="#" @click.prevent="showModal = true">
                  <strong>Terms and Conditions</strong>
                </a>
                of this program and to the data privacy policy of CW Marketing and Development Corporation.
                <sup class="text-danger">*</sup>
              </span>
            </span>
            <!-- Show the TermsAndCondition modal -->
            <TermsAndConditions
              v-if="showModal"
              :logo="siteLogo"
              @cancel="showModal = false"
              @agree="handleAgreement"
            />
          </div>
          <br />
          <br />

          <div v-if="!captchaStatus.match">
            <div>
              <template>
                <b-button size="sm" variant="info" @click="generateCaptcha">
                  Refresh CAPTCHA
                </b-button>
              </template>
            </div>
            <br />
            <div>
              <canvas ref="captchaCanvas" width="150" height="50"></canvas>
            </div>
          </div>
          <div>
            <base-input
              v-if="!captchaStatus.match"
              label="Enter CAPTCHA text"
              required
            >
              <a-input v-model="captcha" placeholder="CAPTCHA text"></a-input>
            </base-input>
            <div v-if="showCaptchaStatus">
              <div class="text-success" v-if="captchaStatus.match">
                Verification complete! You're all set to proceed.
              </div>
              <div class="text-danger" v-if="!captchaStatus.match">
                CAPTCHA did not match. Try again.
              </div>
            </div>
            <div v-if="!captchaStatus.match">
              <template>
                <b-button size="sm" variant="info" @click="validateCaptcha">
                  Verify
                </b-button>
              </template>
            </div>
          </div>
        </div>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import TermsAndConditions from './TermsAndConditions.vue';
const cwULA = process.env.VUE_APP_CW_ULA;

export default {
  props: {
    data: {
      type: Object,
    },
    clpSitePageSettings: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    TermsAndConditions,
  },
  name: 'TermsAndAgreements',
  data() {
    return {
      formData: {
        subscribeMailingList: true,
        termsAndCondition: false,
      },
      captchaText: '',
      captcha: null,
      captchaLength: 6,
      showCaptchaStatus: false,
      captchaStatus: {
        match: false,
      },
      cwUla: cwULA,
      cwUlaLabel: '',
      requiredOk: {
        eula: false,
        captcha: false,
      },
      showModal: false,
    };
  },
  methods: {
    subsMailingList(value) {
      if (value.target.checked) {
        this.formData.subscribeMailingList = true;
      } else {
        this.formData.subscribeMailingList = false;
      }
      this.$emit('set-email-subscribe', value.target.checked);
    },
    agreeUserAgreement(value) {
      if (value) {
        this.requiredOk.eula = true;
        this.formData.termsAndCondition = true;
        if (this.requiredOk.captcha === true) {
          this.$emit('can-create', true);
        }
      } else {
        this.requiredOk.eula = false;
        this.formData.termsAndCondition = false;
        this.$emit('can-create', false);
      }
      this.$emit('set-termsAndConditions', value);
    },
    handleAgreement() {
      this.formData.termsAndCondition = true;
      this.agreeUserAgreement(true);
      this.showModal = false;
    },
    validateCaptcha() {
      if (this.captchaText === this.captcha) {
        this.captchaStatus.match = true;
        this.requiredOk.captcha = true;
        if (this.requiredOk.eula === true) {
          this.$emit('can-create', true);
        }
      } else {
        this.captchaStatus.match = false;
        this.$emit('can-create', false);
      }
      this.showCaptchaStatus = true;
    },

    generateCaptcha() {
      const captchaChars =
        'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
      let c = '';
      for (let i = 0; i < this.captchaLength; i++) {
        c += captchaChars.charAt(
          Math.floor(Math.random() * captchaChars.length)
        );
      }
      this.captchaText = c;
      const canvas = this.$refs.captchaCanvas;
      const ctx = canvas.getContext('2d');

      // Clear
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Background
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Text
      ctx.font = '30px Arial';
      ctx.fillStyle = '#333';
      ctx.setTransform(
        1,
        0.2 - Math.random() * 0.4,
        0.2 - Math.random() * 0.4,
        1,
        0,
        0
      );
      ctx.fillText(this.captchaText, 20, 35);

      // Reset transform
      ctx.setTransform(1, 0, 0, 1, 0, 0);

      // Random lines
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = `rgba(0,0,0,${Math.random()})`;
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }

      // Noise dots
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = '#666';
        ctx.beginPath();
        ctx.arc(
          Math.random() * canvas.width,
          Math.random() * canvas.height,
          1,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
      this.captchaInput = null;
    },
  },
  mounted() {
    this.generateCaptcha();
    this.$emit('can-create', false);
    const data = this.data;
    this.formData.termsAndCondition = data.termsAndConditions;
    this.formData.subscribeMailingList = data.subscribeMailingList;
    if (data.termsAndConditions === true) {
      this.requiredOk.eula = true;
    }
  },
  computed: {
    siteLogo: function () {
      return this.clpSitePageSettings.site_logo !== undefined
        ? '/' + this.clpSitePageSettings.site_logo
        : '/';
    },
  },
};
</script>

<style scoped>
canvas {
  border: 1px solid #ccc;
  display: block;
}

.checkbox-container {
  display: flex;
  align-items: center;
}

.checkbox-label {
  margin-left: 14px;
}
</style>
